<app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

<div class="container px-0 mt-5">
    <div class="grid grid-cols-3 gap-4">
        <div class="col-span-2">
            <form [formGroup]="generalForm">
                <mat-form-field class="w-full">
                    <mat-label>{{'COMMON.NAME' | translate}}</mat-label>
                    <input [readonly]="disableEditName" formControlName="name"
                        class="border-transparent focus:border-transparent focus:ring-0" matInput />
                    @if (generalForm.controls['name'].hasError('required')) {
                    <mat-error>{{'COMMON.FIELD_IS_REQUIRED' | translate}}</mat-error>
                    }
                    <mat-hint *ngIf="disableEditName" align="start">
                        <span class="name-not-editable">
                            {{'ROLE.NOT_ABLE_TO_EDIT_NAME' | translate}}
                        </span>
                    </mat-hint>
                </mat-form-field>
                <mat-form-field class="w-full">
                    <mat-label>{{'COMMON.DESCRIPTION' | translate}}</mat-label>
                    <textarea formControlName="description" cdkAutosizeMinRows="3"
                        class="border-transparent focus:border-transparent focus:ring-0" matInput maxlength="4000"
                        #autosize="cdkTextareaAutosize" cdkTextareaAutosize></textarea>
                    <mat-hint align="start">{{ generalForm.controls['description'].value.length }} /
                        4000</mat-hint>
                </mat-form-field>
            </form>
        </div>
        <div></div>
    </div>

    <div class="col-span-2 mt-5">
        <mat-tab-group *ngIf="!isAddMode" mat-stretch-tabs="false" mat-align-tabs="start">
            <mat-tab label="{{'ROLE.MEMBERS' | translate}}">
                <ng-template matTabContent>
                    <div class="mt-5">
                        <form class="example-form">
                            <div class="example-container">
                                <mat-form-field class="example-form-field">
                                    <mat-label>{{'COMMON.SEARCH' | translate}}</mat-label>
                                    <input class="border-transparent focus:border-transparent focus:ring-0"
                                        [(ngModel)]="filter.keyWord" matInput type="text"
                                        (keydown.enter)="searchByKeyword()" [ngModelOptions]="{standalone: true}"
                                        placeholder="{{'COMMON.SEARCH' | translate}}">
                                    <button matSuffix mat-icon-button aria-label="Clear">
                                        <mat-icon>search</mat-icon>
                                    </button>
                                </mat-form-field>

                                <button class="ms-5" (click)="onAddNewMember()" color="primary" mat-stroked-button>
                                    <mat-icon>add</mat-icon> {{'ROLE.ADD_NEW_MEMBER' | translate}}
                                </button>
                            </div>
                        </form>
                        <div class="mt-5">
                            <table mat-table style="width: 100%; min-width: 600px;" class="ws-table"
                                [dataSource]="dataSource">

                                <ng-container matColumnDef="select">
                                    <th mat-header-cell *matHeaderCellDef>
                                        <div class="flex items-center">
                                            <mat-checkbox color="primary" (change)="$event ? toggleAllRows() : null"
                                                [checked]="selection.hasValue() && isAllSelected()"
                                                [indeterminate]="selection.hasValue() && !isAllSelected()"
                                                [aria-label]="checkboxLabel()">
                                            </mat-checkbox>
                                            <button *ngIf="selection.selected && selection.selected.length > 0"
                                                mat-icon-button aria-label="close dialog" mat-dialog-close
                                                (click)="bulkDeleteMemberInRole()">
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                        </div>
                                    </th>
                                    <td mat-cell *matCellDef="let row">
                                        <mat-checkbox color="primary" (click)="$event.stopPropagation()"
                                            (change)="$event ? selection.toggle(row) : null"
                                            [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                                        </mat-checkbox>
                                    </td>
                                </ng-container>


                                <!-- [matTooltipPosition] Column -->
                                <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef>
                                        {{'COMMON.NAME' | translate}}
                                    </th>
                                    <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                                </ng-container>

                                <!-- Name Column -->
                                <ng-container matColumnDef="type">
                                    <th mat-header-cell *matHeaderCellDef>
                                        {{'COMMON.TYPE' | translate}}
                                    </th>
                                    <td mat-cell *matCellDef="let element"> {{element.type}} </td>
                                </ng-container>

                                <!-- Weight Column -->
                                <ng-container matColumnDef="userName">
                                    <th mat-header-cell *matHeaderCellDef>
                                        {{'COMMON.USER_NAME' | translate}}
                                    </th>
                                    <td mat-cell *matCellDef="let element"> {{element.userName}} </td>
                                </ng-container>

                                <!-- Symbol Column -->
                                <ng-container matColumnDef="email">
                                    <th mat-header-cell *matHeaderCellDef>
                                        {{'COMMON.EMAIL' | translate}}
                                    </th>
                                    <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                                </ng-container>

                                <!-- Symbol Column -->
                                <ng-container matColumnDef="organization">
                                    <th mat-header-cell *matHeaderCellDef>
                                        {{'COMMON.ORGANIZATION' | translate}}
                                    </th>
                                    <td mat-cell *matCellDef="let element"> {{element.organization}} </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            </table>

                            <qms-paginator [length]="totalCount >= 0 ? totalCount : 0" [pageSize]="filter.pageSize"
                                [pageSizeOptions]="[10, 25, 100]" (page)='pageEvent($event)' [size]='"medium"'>
                            </qms-paginator>

                        </div>
                    </div>
                </ng-template>
            </mat-tab>
            <mat-tab label="{{'ROLE.MODULE_PERMISSIONS' | translate}}">
                <ng-template matTabContent>
                    <div class="mt-5">
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{'SIDE_BAR.LOCATION' | translate}}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <mat-slide-toggle [checked]="permission.location_View"
                                matTooltip="{{'ROLE.LOCATION.TOOLTIP_VIEW' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('location_View', $event.checked)" [color]="'primary'">
                                {{'ROLE.LOCATION.VIEW' | translate}}
                            </mat-slide-toggle>
                            <br />
                            <br />
                            <mat-slide-toggle [checked]="permission.location_Add"
                                matTooltip="{{'ROLE.LOCATION.TOOLTIP_ADD' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('location_Add', $event.checked)" [color]="'primary'">
                                {{'ROLE.LOCATION.ADD' | translate}}
                            </mat-slide-toggle>
                            <br />
                            <br />
                            <mat-slide-toggle [checked]="permission.location_Edit"
                                matTooltip="{{'ROLE.LOCATION.TOOLTIP_EDIT' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('location_Edit', $event.checked)" [color]="'primary'">
                                {{'ROLE.LOCATION.EDIT' | translate}}
                            </mat-slide-toggle>
                            <br />
                            <br />
                            <mat-slide-toggle [checked]="permission.location_Delete"
                                matTooltip="{{'ROLE.LOCATION.TOOLTIP_DELETE' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('location_Delete', $event.checked)" [color]="'primary'">
                                {{'ROLE.LOCATION.DELETE' | translate}}
                            </mat-slide-toggle>
                            <br />
                            <br />
                            <mat-slide-toggle [checked]="permission.location_AddSubstance"
                                matTooltip="{{'ROLE.LOCATION.TOOLTIP_ADD_SUBSTANCE' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('location_AddSubstance', $event.checked)"
                                [color]="'primary'">
                                {{'ROLE.LOCATION.ADD_SUBSTANCE' | translate}}
                            </mat-slide-toggle>
                        </mat-expansion-panel>
                        <br />
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{'ROLE.SUBSTANCE.SUBSTANCE' | translate}}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <mat-slide-toggle [checked]="permission.sdsManager_View"
                                matTooltip="{{'ROLE.SUBSTANCE.TOOLTIP_VIEW' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('sdsManager_View', $event.checked)" [color]="'primary'">
                                {{'ROLE.SUBSTANCE.VIEW' | translate}} </mat-slide-toggle>
                            <br />
                            <br />
                            <mat-slide-toggle [checked]="permission.sdsManager_Upload"
                                matTooltip="{{'ROLE.SUBSTANCE.TOOLTIP_UPLOAD' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('sdsManager_Upload', $event.checked)" [color]="'primary'">
                                {{'ROLE.SUBSTANCE.UPLOAD' | translate}}
                            </mat-slide-toggle>
                            <br />
                            <br />
                            <mat-slide-toggle [checked]="permission.sdsManager_Edit"
                                matTooltip="{{'ROLE.SUBSTANCE.TOOLTIP_EDIT' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('sdsManager_Edit', $event.checked)" [color]="'primary'">
                                {{'ROLE.SUBSTANCE.EDIT' | translate}}
                            </mat-slide-toggle>
                            <br />
                            <br />
                            <mat-slide-toggle [checked]="permission.sdsManager_Delete"
                                matTooltip="{{'ROLE.SUBSTANCE.TOOLTIP_DELETE' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('sdsManager_Delete', $event.checked)" [color]="'primary'">
                                {{'ROLE.SUBSTANCE.DELETE' | translate}}
                            </mat-slide-toggle>
                            <br />
                            <br />
                            <mat-slide-toggle [checked]="permission.sdsManager_ViewPortal"
                                matTooltip="{{'ROLE.SUBSTANCE.TOOLTIP_VIEW_PORTAL' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('sdsManager_ViewPortal', $event.checked)"
                                [color]="'primary'">
                                {{'ROLE.SUBSTANCE.VIEW_PORTAL' | translate}}
                            </mat-slide-toggle>
                            <br />
                            <br />
                            <mat-slide-toggle [checked]="permission.sdsManager_AddFromPortal"
                                matTooltip="{{'ROLE.SUBSTANCE.TOOLTIP_ADD_FROM_PORTAL' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('sdsManager_AddFromPortal', $event.checked)"
                                [color]="'primary'">
                                {{'ROLE.SUBSTANCE.ADD_FROM_PORTAL' | translate}}
                            </mat-slide-toggle>
                        </mat-expansion-panel>
                        <br />
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{'ROLE.RISK_ANALYSIS.RISK_ANALYSIS' | translate}}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <mat-slide-toggle [checked]="permission.riskAnalysis_Add"
                                matTooltip="{{'ROLE.RISK_ANALYSIS.TOOLTIP_ACCESS' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('riskAnalysis_Add', $event.checked)" [color]="'primary'">
                                {{'ROLE.RISK_ANALYSIS.MANAGERMENT' | translate}}
                            </mat-slide-toggle>
                        </mat-expansion-panel>
                        <br />
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{'SIDE_BAR.WORK_ASSIGNMENT' | translate}}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <mat-slide-toggle [checked]="permission.workAssignment_WorkAssignmentManager"
                                matTooltip="{{'ROLE.WORK_ASSIGNMENT.TOOLTIP_MY_WA' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('workAssignment_WorkAssignmentManager', $event.checked)"
                                [color]="'primary'">
                                {{'SIDE_BAR.WORK_ASSIGNMENT' | translate}}
                            </mat-slide-toggle>
                            <br />
                            <br />
                            <mat-slide-toggle [checked]="permission.workAssignment_ShowExecutiveInformation"
                                matTooltip="{{'ROLE.WORK_ASSIGNMENT.TOOLTIP_SHOW_EXECUTIVE_INFO' | translate}}"
                                mode="dark" [matTooltipPosition]="'right'"
                                (change)="onChangePermission('workAssignment_ShowExecutiveInformation', $event.checked)"
                                [color]="'primary'">
                                {{'ROLE.WORK_ASSIGNMENT.SHOW_EXECUTIVE_INFO' | translate}}
                            </mat-slide-toggle>
                            <br />
                            <br />
                            <mat-slide-toggle [checked]="permission.workAssignment_EditAndDuplicateWA"
                                matTooltip="{{'ROLE.WORK_ASSIGNMENT.TOOLTIP_EDIT_AND_DUP_WA' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('workAssignment_EditAndDuplicateWA', $event.checked)"
                                [color]="'primary'">
                                {{'ROLE.WORK_ASSIGNMENT.EDIT_AND_DUP_WA' | translate}}
                            </mat-slide-toggle>
                            <br />
                            <br />
                            <mat-slide-toggle [checked]="permission.workAssignment_SeeRegistrations"
                                matTooltip="{{'ROLE.WORK_ASSIGNMENT.TOOLTIP_SEE_REGISTRATIONS' | translate}}"
                                mode="dark" [matTooltipPosition]="'right'"
                                (change)="onChangePermission('workAssignment_SeeRegistrations', $event.checked)"
                                [color]="'primary'">
                                {{'ROLE.WORK_ASSIGNMENT.SEE_REGISTRATIONS' | translate}}
                            </mat-slide-toggle>
                            <br />
                            <br />
                            <mat-slide-toggle [checked]="permission.workAssignment_ViewAllWorkAssignment"
                                matTooltip="{{'ROLE.WORK_ASSIGNMENT.TOOLTIP_VIEW_ALL_WA' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('workAssignment_ViewAllWorkAssignment', $event.checked)"
                                [color]="'primary'">
                                {{'ROLE.WORK_ASSIGNMENT.VIEW_ALL_WA' | translate}}
                            </mat-slide-toggle>
                        </mat-expansion-panel>
                        <br />
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{'ROLE.EXPOSURE_FORM.EXPOSURE_REGISTER' | translate}}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <mat-slide-toggle [checked]="permission.exposureForm_Add"
                                matTooltip="{{'ROLE.EXPOSURE_FORM.TOOLTIP_MY_EXPSOURE' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('exposureForm_Add', $event.checked)" [color]="'primary'">
                                {{'SIDE_BAR.MY_EXPOSURE' | translate}}
                            </mat-slide-toggle>
                        </mat-expansion-panel>
                        <br />
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{'ROLE.TASK_MANAGER.RISK_SUBSTITUTION_TASK' | translate}}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <mat-slide-toggle [checked]="permission.taskManager_ViewAll"
                                matTooltip="{{'ROLE.TASK_MANAGER.TOOLTIP_VIEW_RISK' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('taskManager_ViewAll', $event.checked)"
                                [color]="'primary'">
                                {{'ROLE.TASK_MANAGER.VIEW_ALL_RISK_MEASURE_TASKS' | translate}}
                            </mat-slide-toggle>
                            <br />
                            <br />
                            <mat-slide-toggle [checked]="permission.taskManager_EditAllRiskTask"
                                matTooltip="{{'ROLE.TASK_MANAGER.TOOLTIP_MANAGER' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('taskManager_EditAllRiskTask', $event.checked)"
                                [color]="'primary'">
                                {{'ROLE.TASK_MANAGER.RISK_MEASURE_TASK_MANAGER' | translate}}
                            </mat-slide-toggle>
                            <br />
                            <br />
                            <mat-slide-toggle [checked]="permission.taskManager_AccessSubstitutionModule"
                                matTooltip="{{'ROLE.TASK_MANAGER.TOOLTIP_ACCESS' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('taskManager_AccessSubstitutionModule', $event.checked)"
                                [color]="'primary'">
                                {{'ROLE.TASK_MANAGER.ACCESS_SUBSTITUTION_MODULE' | translate}}
                            </mat-slide-toggle>
                            <br />
                            <br />
                            <mat-slide-toggle [checked]="permission.taskManager_SubstitutionManager"
                                matTooltip="{{'ROLE.TASK_MANAGER.TOOLTIP_SUBSTITUTION_MANAGER' | translate}}"
                                mode="dark" [matTooltipPosition]="'right'"
                                (change)="onChangePermission('taskManager_SubstitutionManager', $event.checked)"
                                [color]="'primary'">
                                {{'ROLE.TASK_MANAGER.SUBSTITUTION_MANAGER' | translate}}
                            </mat-slide-toggle>
                        </mat-expansion-panel>
                        <br />
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{'ROLE.PROJECT.PROJECT' | translate}}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <mat-slide-toggle [checked]="permission.project_View"
                                matTooltip="{{'ROLE.PROJECT.TOOLTIP_VIEW_PROJECT' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('project_View', $event.checked)" [color]="'primary'">
                                {{'ROLE.PROJECT.VIEW_PROJECT' | translate}}
                            </mat-slide-toggle>
                            <br />
                            <br />
                            <mat-slide-toggle [checked]="permission.project_Manage"
                                matTooltip="{{'ROLE.PROJECT.TOOLTIP_MANAGE_PROJECT' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('project_Manage', $event.checked)" [color]="'primary'">
                                {{'ROLE.PROJECT.MANAGE_PROJECT' | translate}}
                            </mat-slide-toggle>
                        </mat-expansion-panel>
                        <br />
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{'ROLE.HUB_SHARING.HUB_SHARING' | translate}}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <br />
                            <mat-slide-toggle [checked]="permission.hub_View"
                                matTooltip="{{'ROLE.HUB_SHARING.TOOLTIP_VIEW_HUB' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'" (change)="onChangePermission('hub_View', $event.checked)"
                                [color]="'pPmary'">
                                {{'ROLE.HUB_SHARING.VIEW_HUB' | translate}}
                            </mat-slide-toggle>
                            <br />
                            <br />
                            <mat-slide-toggle [checked]="permission.hub_Manage"
                                matTooltip="{{'ROLE.HUB_SHARING.TOOLTIP_MANAGE_HUB' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('hub_Manage', $event.checked)" [color]="'primary'">
                                {{'ROLE.HUB_SHARING.MANAGE_HUB' | translate}}
                            </mat-slide-toggle>
                        </mat-expansion-panel>
                        <br />
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{'SIDE_BAR.USER_ACCESS' | translate }}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <mat-slide-toggle [checked]="permission.userAccess_LocalEdit"
                                matTooltip="{{'ROLE.USER_ACCESS.LOCAL_EDIT_USER_ACCESS_TOOLTIP' | translate}}"
                                mode="dark" [matTooltipPosition]="'right'"
                                (change)="onChangePermission('userAccess_LocalEdit', $event.checked)"
                                [color]="'primary'">
                                {{'ROLE.USER_ACCESS.LOCAL_EDIT_USER_ACCESS' | translate }}
                            </mat-slide-toggle>
                            <br /><br />
                            <mat-slide-toggle [checked]="permission.userAccess_FullEdit"
                                matTooltip="{{'ROLE.USER_ACCESS.FULL_EDIT_USER_ACCESS_TOOLTIP' | translate}}"
                                mode="dark" [matTooltipPosition]="'right'"
                                (change)="onChangePermission('userAccess_FullEdit', $event.checked)"
                                [color]="'primary'">
                                {{'ROLE.USER_ACCESS.FULL_EDIT_USER_ACCESS' | translate }}
                            </mat-slide-toggle>
                            <div *ngIf="permission.userAccess_FullEdit" class="mt-8">
                                <div class="flex-aligns-center ">
                                    <span class="width-150">{{this.accessManageLocations.length || 0}}
                                        {{'COMMON.LOCATIONS' |
                                        translate}}</span>
                                    <button qms-btn-outlined (click)="openSelectLocationDialog()">
                                        <mat-icon>location_on</mat-icon>
                                        {{'ROLE.USER_ACCESS.ADJUST_LOCATIONS' | translate }}
                                    </button>
                                </div>

                                <div class="flex-aligns-center mt-8">
                                    <span class="width-150">{{this.accessManageUserGroups.length || 0}}
                                        {{'COMMON.ROLES' |
                                        translate}}</span>
                                    <button qms-btn-outlined (click)="openModifyUserRolesPopup()">
                                        <mat-icon>person_pin</mat-icon>
                                        {{'ROLE.USER_ACCESS.ADJUST_ROLES' | translate }}
                                    </button>
                                </div>
                            </div>
                        </mat-expansion-panel>
                        <br />
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{'ROLE.OTHERS.OTHERS' | translate}}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <mat-slide-toggle [checked]="permission.others_Print"
                                matTooltip="{{'ROLE.OTHERS.TOOLTIP_PRINT' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('others_Print', $event.checked)" [color]="'primary'">
                                {{'ROLE.OTHERS.PRINT' | translate}}
                            </mat-slide-toggle>
                            <br />
                            <br />
                            <mat-slide-toggle [checked]="permission.others_ReadAllDepartments"
                                matTooltip="{{'ROLE.OTHERS.TOOLTIP_READ_ALL_DEPARTMENT' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('others_ReadAllDepartments', $event.checked)"
                                [color]="'primary'">
                                {{'ROLE.OTHERS.READ_ALL_LOCATIONS' | translate}}
                            </mat-slide-toggle>

                            <br />
                            <br />

                            <mat-slide-toggle [checked]="permission.others_Administrator"
                                matTooltip="{{'ROLE.OTHERS.TOOLTIP_ADMIN' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('others_Administrator', $event.checked)"
                                [color]="'primary'">
                                {{'SIDE_BAR.ADMINISTRATOR' | translate}}
                            </mat-slide-toggle>
                            <br />
                            <br />

                            <mat-slide-toggle [checked]="permission.others_SDSCreator"
                                matTooltip="{{'ROLE.OTHERS.TOOLTIP_ADMIN' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('others_SDSCreator', $event.checked)" [color]="'primary'">
                                {{'SIDE_BAR.PUBLISHER' | translate}}
                            </mat-slide-toggle>
                            <br />
                            <br />

                        </mat-expansion-panel>
                        <br />
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{'SIDE_BAR.REPORT' | translate}}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <mat-slide-toggle [checked]="permission.report_Exposure"
                                matTooltip="{{'ROLE.REPORT.TOOLTIP_EXPOSURE_REPORT' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('report_Exposure', $event.checked)" [color]="'primary'">
                                {{'SIDE_BAR.EXPOSURE_REPORT' | translate}}
                            </mat-slide-toggle>
                            <br />
                            <br />
                            <mat-slide-toggle [checked]="permission.report_ShowIDAndWorkTitle"
                                [disabled]="!isSystemAdmin" [class.d-none]="!isSystemAdmin" *ngIf="isSystemAdmin"
                                matTooltip="{{'ROLE.REPORT.SHOW_ID_AND_WORK_TITLE_TOOLTIP' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('report_ShowIDAndWorkTitle', $event.checked)"
                                [color]="'primary'">
                                {{'ROLE.REPORT.SHOW_ID_AND_WORK_TITLE' | translate}}
                            </mat-slide-toggle>
                            <br *ngIf="isSystemAdmin" />
                            <br *ngIf="isSystemAdmin" />
                            <mat-slide-toggle [checked]="permission.report_RiskAssessment"
                                matTooltip="{{'ROLE.REPORT.TOOLTIP_RISK_ASSESSMENT_REPORT' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('report_RiskAssessment', $event.checked)"
                                [color]="'primary'">
                                {{'SIDE_BAR.RISK_ASSESSMENT_REPORT' | translate}}
                            </mat-slide-toggle>
                            <br />
                            <br />
                            <mat-slide-toggle [checked]="permission.report_Stock"
                                matTooltip="{{'ROLE.REPORT.TOOLTIP_STOCK_REPORT' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('report_Stock', $event.checked)" [color]="'primary'">
                                {{'SIDE_BAR.STOCK_REPORT' | translate}}
                            </mat-slide-toggle>
                            <br />
                            <br />
                            <mat-slide-toggle [checked]="permission.report_Substitution"
                                matTooltip="{{'ROLE.REPORT.TOOLTIP_SUBSTITUTION_REPORT' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('report_Substitution', $event.checked)"
                                [color]="'primary'">
                                {{'SIDE_BAR.SUBSTITUTION_REPORT' | translate}}
                            </mat-slide-toggle>
                        </mat-expansion-panel>
                        <br />
                        <mat-expansion-panel *ngIf="isAnonymousRole">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{ 'COMMON.ANONYMOUS' | translate }}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <mat-slide-toggle [checked]="permission.anonymous_ReadAllURL"
                                matTooltip="{{'ROLE.ANONYMOUS.READ_ALL_URL_TOOLTIP' | translate}}" mode="dark"
                                [matTooltipPosition]="'right'"
                                (change)="onChangePermission('anonymous_ReadAllURL', $event.checked)"
                                [color]="'primary'">
                                {{ 'ROLE.ANONYMOUS.READ_ALL_URL' | translate }}
                            </mat-slide-toggle>
                        </mat-expansion-panel>
                        <br />
                    </div>
                </ng-template>
            </mat-tab>
        </mat-tab-group>

        <div class="flex justify-end mt-5">
            <button class="me-5" [routerLink]="['/admin/roles']" color="primary" mat-stroked-button>
                {{'COMMON.CANCEL' | translate}}
            </button>

            <button color="primary" (click)="onSubmit()" mat-flat-button>
                {{'COMMON.SAVE' | translate}}
            </button>
        </div>
    </div>


</div>